module.exports = __webpack_public_path__ + "static/media/persianGulf.42ffed65.jpg";